<template>
    <div class="video-image-container">
      <img  @click="$emit('play', true)" :src="getPlayImage">
    </div>
</template>

<script>

import { eventBus } from '@/main.js'
import EventConstants from '@/constants/Events'

export default {
  data () {
    return {
      isCompleted: false,
      isPlaying: false,
      counter: 0
    }
  },
  props: {
    totalVideoLength: {
      type: Number
    },
    videoList: {
      type: Array,
      default: function () {
        return []
      }
    },
    type: {
      type: Number
    }
  },
  methods: {
    onError: function (event) {
      this.$emit('onError', event)
    },
    onTime: function (event) {
      this.$emit('onTime', event)
    },
    onPlay: function (event) {
      if (!this.isPlaying) {
        this.isPlaying = true
        this.isCompleted = false
        this.$emit('onPlay', event)
      }
    },
    onComplete: function (event) {
      if (this.isPlaying) {
        this.isPlaying = false
        this.isCompleted = true
        this.counter = 0
        this.$emit('onComplete', event)
        this.videoList.splice(0, 1)
      }
    },
    isVideoFinish: function (secondsToStart) {
      return this.totalVideoLength <= this.counter
    },
    getTimeEvent: function (secondsToStart) {
      return {
        data: {
          currentTime: secondsToStart
        }
      }
    },
    onEventTimerTick (secondsToStart) {
      this.counter++
      if (this.isVideoFinish()) {
        if (!this.isCompleted) {
          this.onComplete()
        }
        return
      }
      if (!this.isPlaying) {
        this.onPlay()
      }
      let event = this.getTimeEvent(this.counter)
      this.onTime(event)
    }
  },
  watch: {
    totalVideoLength: function (val, old) {
      setTimeout(this.onPlay, 1000)
    },
    type: function (val, old) {
    }
  },
  created: function () {
    eventBus.$on(EventConstants.VSOCCER_TIMER_TICK, this.onEventTimerTick)
    this.onPlay()
  },
  beforeDestroy () {
    eventBus.$off(EventConstants.VSOCCER_TIMER_TICK, this.onEventTimerTick)
  },
  computed: {
    getPlayImage: function () {
      return this.type > 1 ? 'https://cloud.aleacontrol.com/media/vSoccer/vs_champions_jp.png' : 'https://cloud.aleacontrol.com/media/vSoccer/vs_stadium_jp.png'
    }
  }
}
</script>
